import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import * as Icon from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { hideDialog, showDialog } from 'redux/alerts/actions';
import { useDispatch } from 'react-redux';
import api from 'api';
import NewForm from './NewForm';
import { ToastsStore } from 'react-toasts';

const choices = {
    NEW: 'NEW',
    EXISTING: 'EXISTING',
    COPY: 'COPY',
};

const defaultObject = {
    sortOrder: '1',
    qsId: 'formObject',
    type: 'formObject',
    xs: 12,
    sm: 6,
    md: '6',
    elevation: 2,
};

const FormEntryButton = ({ pageId, rowId, classes }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadForms = () => {
        setLoading(true);
        api.forms
            .all()
            .then((results) => {
                setForms(results);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const closeDialog = () => {
        dispatch(hideDialog());
    };

    const newObject = `/settings/pages/form-object/${pageId}/${rowId}`;
    const existingObject = (objectId) =>
        `/settings/pages/form-object/${pageId}/${rowId}/object/${objectId}`;

    const existingForm = (formId) => {
        const objectData = {
            ...defaultObject,
            page: pageId,
            row: rowId,
            form: formId,
        };

        api.objects
            .create(pageId, objectData)
            .then((results) => {
                closeDialog();
                console.log(results);
                if (results && results._id) {
                    history.push(existingObject(results._id));
                } else {
                    ToastsStore.error('Failed to create Form Object');
                }
            })
            .catch((err) => {
                ToastsStore.error('Failed to create Form Object');
                closeDialog();
                console.log(err);
            });
    };

    const cloneForm = (formId) => {
        api.forms
            .clone(formId)
            .then((results) => {
                console.log(results);
                existingForm(results._id);
            })
            .catch((err) => {
                ToastsStore.error('Failed to clone Form Object');
                console.log(err);
            });
    };

    const submitForm = (values) => {
        const { choice, formId } = values;
        switch (choice) {
            case choices.NEW:
                closeDialog();
                history.push(newObject);
                break;
            case choices.EXISTING:
                existingForm(formId);
                break;
            case choices.COPY:
                cloneForm(formId);
                break;
        }
    };

    const openDialog = () => {
        dispatch(
            showDialog({
                open: true,
                title: 'Custom Form',
                content: (
                    <NewForm
                        forms={forms}
                        submitForm={submitForm}
                        choices={choices}
                    />
                ),
                handleClose: closeDialog,
            })
        );
    };

    useEffect(() => {
        loadForms();
    }, []);

    return (
        <Tooltip title={'Custom Form'} placement={'top'}>
            <Button
                className={clsx(
                    classes.buttonSecondary,
                    'u-mr-small u-p-zero  c-btn--small'
                )}
                onClick={openDialog}
                disabled={loading}
            >
                <Icon.ListAlt />
            </Button>
        </Tooltip>
    );
};

export default FormEntryButton;
